/**
 * Roles - to grant different access levels
 * @type {{User: string, Organization: string, Admin: string, ngo: string}}
 */
const Roles = {
  User: 'user',
  Organization: 'organization',
  Admin: 'admin',
  ngo: 'ngo',
};

const allRoles = Object.values(Roles);

export default Roles;
export { Roles, allRoles };
